import { createContext, useContext, useState, useMemo, useCallback } from "react";
import translations from "./translations";

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem('appLang') || 'hr');

  const switchLang = useCallback((newLang) => {
    setLang(newLang);
    localStorage.setItem('appLang', newLang);
  }, []);

  const t = useCallback((key) => translations[lang]?.[key] || translations['hr']?.[key] || key, [lang]);

  const value = useMemo(() => ({ lang, switchLang, t }), [lang, switchLang, t]);

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => useContext(LanguageContext);
